import { render, staticRenderFns } from "./FacilitiesManage.vue?vue&type=template&id=4c9af6eb&scoped=true&"
import script from "./FacilitiesManage.vue?vue&type=script&lang=js&"
export * from "./FacilitiesManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9af6eb",
  null
  
)

export default component.exports